import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { PolicyImpactData } from '../types';

export abstract class MaintenanceWindowsDeleteDialogBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMaintenanceWindowOperationSummary(
    companyId: string,
    maintenanceWindowIds: string[]
  ): Promise<PolicyImpactData>;
}
